Number.prototype.toEuro = function(n=2) {
    if (isNaN(Number(this))) {
        return this;
    }
    return Number(this).toLocaleString('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: n,
        maximumFractionDigits: n,
    });
};
Number.prototype.toCurrency = function(n=2) {
    if (isNaN(this)) {
        console.log('NaN')
        return this;
    }
    return this.toLocaleString('en-US', {
        minimumFractionDigits: n,
        maximumFractionDigits: n,
    });
};
Number.prototype.toOrdinal = function () {
    const num = this.valueOf(); // Get the actual number
    if (num % 100 >= 11 && num % 100 <= 13) return `${num}th`;
    switch (num % 10) {
        case 1:
            return `${num}st`;
        case 2:
            return `${num}nd`;
        case 3:
            return `${num}rd`;
        default:
            return `${num}th`;
    }
};